import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {PowerSearchLabelHdrsContainerModel} from '../../../../../../models';


@Injectable({providedIn: 'root'})

export class PowerSearchLabelHdrsService extends BaseApiTemplateService<PowerSearchLabelHdrsContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/label-hdrs/public-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/label-hdrs/public-ep';
    this.httpClient = http;
  }
}
